import React from 'react'

import ExternalNavigation from 'components/Navigation/ExternalNavigation/ExternalNavigation'

import './app-header-desktop-external-nav.pcss'

const AppHeaderDesktopExternalNav = ({ ...rest }) => {
    return (
        <div className="app-header-desktop-external-nav">
            <ul>
                <ExternalNavigation {...rest} />
            </ul>
        </div>
    )
}

AppHeaderDesktopExternalNav.propTypes = {
    ...ExternalNavigation.propTypes,
}

export default AppHeaderDesktopExternalNav
